import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Link, useSearchParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import JobCard from '../../common/Cards/JobCard/JobCard';
import SideJobCard from '../../common/Cards/SideJobCard/SideJobCard';
import classes from './scss/jobsFeed.module.scss';
import PaginationPanel from '../../common/PaginationPanel/PaginationPanel';
import JobCardSkeleton from '../../common/Skeletons/JobCardSkeleton';

function JobsFeed(props) {
  const { jobsData, counter, savedJobs, currentPage, setCurrentPage } = props;

  const pendingFetch = useSelector((state) => state.jobs.pendingFlag);
  const [sideJob, setSideJob] = useState(null);
  const [focusedJobId, setFocusedJobId] = useState('');

  const pagination = useSelector((state) => state.jobs.pagination);
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  const applyHandler = (id) => {
    localStorage.setItem(`OpenedJobId`, JSON.stringify(id));
    // navigate('/jobs?action=apply');
    setSearchParams({ action: 'apply' });
  };

  return (
    <>
      <div className="row pt-5">
        <div className={`${classes.title} col`}>
          <h1 className="d-inline align-middle">{t('dashboard.jobs.all')}</h1>
          {Array.isArray(jobsData) && (
            <span className={`${classes.found} align - middle`}>
              <Trans i18nKey="dashboard.jobs.foundjobs" counter={counter}>
                Found {{ counter }} job{counter > 1 ? 's' : ''}
              </Trans>
            </span>
          )}
        </div>
      </div>
      <Grid container columnSpacing={3} mt={2}>
        {pendingFetch ? (
          <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', gap: '19px' }}>
            {Array.from({ length: 3 }, (v, k) => k).map((_, idx) => (
              /* eslint-disable-next-line react/no-array-index-key */
              <JobCardSkeleton key={idx} />
            ))}
          </Grid>
        ) : (
          <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', gap: '19px' }}>
            {jobsData?.length === 0 || !Array.isArray(jobsData) ? (
              <h6>
                <Trans i18nKey="dashboard.jobs.nojobs">
                  No jobs available - <Link to="/dashboard/jobs">view all jobs</Link>
                </Trans>
              </h6>
            ) : (
              jobsData?.map((item) => (
                <JobCard
                  key={item?.Id}
                  data={item}
                  onClick={() => setSideJob(item)}
                  isFocused={focusedJobId === item?.Id}
                  setFocus={() => setFocusedJobId(item?.Id)}
                />
              ))
            )}
            <div className={classes.pagination}>
              {Array.isArray(jobsData) && (
                <PaginationPanel total={pagination?.TotalPages} active={currentPage} setActive={setCurrentPage} />
              )}
            </div>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={6}
          className={`${classes.viewJobContainer} view_job_container col-md-6 offset-md-1 mb-5 pb-4 ${
            sideJob ? classes.active : ''
          }`}
        >
          {sideJob && (
            <div className={classes.stickyCard}>
              <SideJobCard
                job={sideJob}
                savedJobs={savedJobs}
                jobsData={jobsData}
                closeHandler={() => setSideJob(null)}
                applyHandler={applyHandler}
              />
            </div>
          )}
        </Grid>
      </Grid>
      <Outlet />
    </>
  );
}

export default JobsFeed;
